import React from "react";
import "../../styles/Footer/Footer.css";

const Footer = () => {

    return(
        <div className ="footer">
        @ 2024 Navneet PortFolio
        </div>
    )
}

export default Footer;